// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NinjaTag_wrapper__2i8-v","imageWrapper":"NinjaTag_imageWrapper__1wtju","loading":"NinjaTag_loading__3-ONR","transition":"NinjaTag_transition__3rIV4"};